import { Container, Paper, Typography } from "@mui/material";
import SearchFilter from "../components/SearchFilter";
import SearchResultsTable from "../components/SearchResultsTable";
import { useSearchLots } from "../hooks/useSearchLots";

const SearchPage = () => {
  const {
    data,
    hiddenData,
    easyData,
    similarData,
    isLoading,
    isHiddenLoading,
    easyLoading,
    similarLoading,
    filters,
    setFilters,
    page,
    setPage,
    total,
    hiddenTotal,
    easyTotal,
    similarTotal,
    pageLimit,
    setPageLimit,
    fetchEasyLots,
    fetchSimilarLots,
  } = useSearchLots();

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Поиск лотов
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <SearchFilter filters={filters} setFilters={setFilters} />
      </Paper>

      <Paper sx={{ p: 2 }}>
        <SearchResultsTable
          data={data}
          hiddenData={hiddenData}
          easyData={easyData}
          similarData={similarData}
          isLoading={isLoading}
          isHiddenLoading={isHiddenLoading}
          isEasyLoading={easyLoading}
          isSimilarLoading={similarLoading}
          total={total}
          hiddenTotal={hiddenTotal}
          easyTotal={easyTotal}
          similarTotal={similarTotal}
          page={page}
          setPage={setPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          fetchEasyLots={fetchEasyLots}
          fetchSimilarLots={fetchSimilarLots}
        />
      </Paper>
    </Container>
  );
};

export default SearchPage;
